import React from 'react';
import { Switch, Redirect, Route } from 'react-router';
import { parse } from 'querystring';
import '../assets/stylesheets/App.css';
import 'font-awesome/css/font-awesome.css';
import { store } from '../store';
import { autoLogin, handleInvite, refresh } from '../actions/auth';
import { geoLocate } from '../actions/customer';
import { checkInvite } from '../actions/merchant';
import * as restoreState from '../utils/restore-from-state';
import { HeaderContainer } from './Header';
import { FooterContainer } from './Footer';
import { NavigationContainer } from './Social/Navigation';
import SystemMessage from './SystemMessage';

import asyncComponent from "./AsyncComponent";
import { LandingContainer } from './Landing';

const AsyncDashboard = asyncComponent(() => import("./Dashboard"));
const AsyncSources = asyncComponent(() => import("./SubscriberDashboard/Sources"));
const AsyncPlans = asyncComponent(() => import("./Plans"));
const AsyncVerification = asyncComponent(() => import("./Verify"));

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    store.getState().auth.get('user').get('isLoggedIn') ? (
      <Component {...props} />
    ) : (
      <Redirect to={{
        pathname: '/',
        state: { from: props.location }
      }} />
    )
  )} />
);

export class App extends React.Component {
  componentWillMount() {
    let user = JSON.parse(localStorage.getItem('user'));

    const async_load = function() {
      var first, s;
      s = document.createElement('script');
      s.src = '//d2wy8f7a9ursnm.cloudfront.net/bugsnag-3.min.js';
      s['data-apikey']='d92de1faf278e19925bae56ec7a0be2a'
      s.type = 'text/javascript';
      s.async = true;
      first = document.getElementsByTagName('script')[0];
      return first.parentNode.insertBefore(s, first);
    };

    if (process.env.NODE_ENV !== 'development') {
      if (window.attachEvent != null) {
        window.attachEvent('onload', async_load);
      } else {
        window.addEventListener('load', async_load, false);
      }
    }

    const query = parse(window.location.search);

    if (query['?ml']) {
      store.dispatch(refresh(query['?ml']));
    } else if (query['?invite_id']) {
      store.dispatch(checkInvite(query['?invite_id']));
    }

    restoreState.restoreLocation() || store.dispatch(geoLocate());

    // no need to worry about whether the token is valid here, as it's handled at each route
    if (user && user.user_id && user.access_token && !store.getState().auth.get('user').get('isLoggedIn')) {
      store.dispatch(autoLogin(user, true))
        .then(res => store.dispatch(handleInvite()));
    }
  }

  render() {
    return (
      <div>
        <HeaderContainer />
        <SystemMessage />
        <NavigationContainer {...this.props} />

        <div>
          <Switch>
            <Route exact path="/" component={LandingContainer} />
            <PrivateRoute path="/dashboard" component={AsyncDashboard} />
            <PrivateRoute path="/search" component={LandingContainer} />
            <PrivateRoute path='/sources' component={AsyncSources} />
            <PrivateRoute path='/plan' component={AsyncPlans} />
            <PrivateRoute path='/verify' component={AsyncVerification} />
          </Switch>
        </div>

        <FooterContainer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js